import React, { useMemo, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import { useQuery } from "@apollo/client";
import {
  LOCKER_FEE_TABLE,
  LOCKER_FEE_TABLE_UNGROUPED,
} from "../../../constants/graphql/locker-queries";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Button as PrimereactBUtton } from "primereact/button";
import { useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { Accordion, AccordionTab } from "primereact/accordion";
import { QUERY_LOCKER_TYPE } from "../../../constants/graphql/parter-perf-graphql";

export default function LockerFees() {
  const [lockerFeeData, setlockerFeeData] = useState([]);

  const lockerFeeTable = useQuery(LOCKER_FEE_TABLE, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });

  const lockerFeeTableByType = useQuery(LOCKER_FEE_TABLE_UNGROUPED, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const allLockerTypes = useQuery(QUERY_LOCKER_TYPE);

  const lockerTypesData = useMemo(() => {
    if (allLockerTypes.data && allLockerTypes.data.lockerTypes) {
      return allLockerTypes.data.lockerTypes.map((type) => ({
        label: type.lockerType,
        value: type.lockerTypeId,
      }));
    }
    return [];
  }, [allLockerTypes.data]);

  console.log({ lockerTypesData });
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );

  React.useEffect(() => {
    if (lockerFeeTable.data) {
      setlockerFeeData(lockerFeeTable.data.lockerFeeTable);
    }
  }, [lockerFeeTable.data]);

  const groupedData = useMemo(() => {
    if (!lockerFeeTableByType.data?.lockerFeesByType) {
      return {};
    }

    const data = lockerFeeTableByType.data.lockerFeesByType;

    // Get all unique locker types
    const lockerTypes = [...new Set(data.map((item) => item.lockerType))];

    const result = {};

    lockerTypes.forEach((lockerType) => {
      const itemsForLockerType = data.filter(
        (item) => item.lockerType === lockerType
      );

      result[lockerType] = {
        partners: itemsForLockerType.filter(
          (item) => item.partnerType !== null && item.partnerTypeId !== null
        ),
        users: itemsForLockerType.filter(
          (item) => item.userType !== null && item.userTypeId !== null
        ),
      };
    });

    return result;
  }, [lockerFeeTableByType.data]);

  const headerAdd = ({ type, lockerTypeId, partnerTypes }) => {
    if (type == 1) {
      return (
        <button
          className={`px-4 py-1 rounded-md font-bold flex gap-1 justify-center bg-secondary-darkGray text-primary-primaryYellow  ${
            accessPermission.lockerFees === 1 ||
            accessPermission.lockerFees === "1"
              ? "hidden"
              : ""
          }`}
          // onClick={() => {
          // 	window.location.href = `/operator/admin/locker-fees/add-user-fees/${partnerTypes}/${lockerTypeId}`;
          // }}
          onClick={() => {
            window.open(
              `/operator/admin/locker-fees/add-user-fees/${lockerTypeId}`,
              "_blank"
            );
          }}
        >
          <p className="my-auto">{"ADD"}</p>
        </button>
      );
    }
    if (type === 0) {
      return (
        <button
          className={`px-4 py-1 rounded-md font-bold flex gap-1 justify-center bg-secondary-darkGray text-primary-primaryYellow  ${
            accessPermission.lockerFees === 1 ||
            accessPermission.lockerFees === "1"
              ? "hidden"
              : ""
          }`}
          // onClick={() => {
          // 	window.location.href = `/operator/admin/locker-fees/add-partner-fees/${partnerTypes}/${lockerTypeId}`;
          // }}
          onClick={() => {
            window.open(
              `/operator/admin/locker-fees/add-partner-fees/${lockerTypeId}`,
              "_blank"
            );
          }}
        >
          <p className="my-auto">{"ADD"}</p>
        </button>
      );
    }
  };

  const CustomTable = ({ data, title, id }) => {
    return (
      <div className="w-1/2">
        <p className="font-bold text-center">{title}</p>
        <div className="flex flex-row">
          <p className="text-start  mr-[3px] ">Total: </p>
          <p className="font-bold text-start  text-black">{data.length}</p>
        </div>
        <DataTable
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="Page {currentPage} of {totalPages}"
          paginator
          paginatorRight
          rowsPerPageOptions={[5, 10, 20, 50]}
          rows={5}
          value={data}
          sortField={title.split(" ")[0] == "User" ? "userType" : "partnerType"}
          sortOrder={-1}
          tableStyle={{ minWidth: "90%" }}
          exportFilename="Locker Fees"
          stripedRows={true}
          showGridlines
          className="border-2 border-stone-400"
        >
          <Column
            header={
              title.split(" ")[0] == "User" ? "User Type" : "Partner Type"
            }
            field={title.split(" ")[0] == "User" ? "userType" : "partnerType"}
            sortable
            style={{ minWidth: "40%" }}
            headerStyle={{ backgroundColor: "#facc15", color: "black" }}
          ></Column>

          <Column
            header={headerAdd({
              type: title.split(" ")[0] == "User" ? 1 : 0,
              lockerTypeId: id,
              partnerTypes: JSON.stringify(data),
            })}
            field="action"
            style={{ minWidth: "10%" }}
            headerStyle={{ backgroundColor: "#facc15", color: "black" }}
            body={(rowData) =>
              actionBodyTemplate(
                rowData,
                id,
                title.split(" ")[0] == "User" ? 1 : 0
              )
            }
          ></Column>
        </DataTable>
      </div>
    );
  };

  const headerClassName = (lockerTypeId, isSpecialColumn = false) => {
    const baseClasses = "border border-gray-400 text-black";

    if (isSpecialColumn) {
      const bgClass =
        lockerTypeId === "1"
          ? "bg-primary-primaryYellowLight"
          : "bg-primary-primaryYellow";
      return `${bgClass} ${baseClasses}`;
    }

    // For all other columns
    return `bg-primary-primaryYellowLight ${baseClasses}`;
  };
  const getLockerTypeLabel = (lockerTypeId) => {
    const type = lockerTypesData.find((lt) => lt.value === lockerTypeId);
    return type ? type.label : "Unknown";
  };

  const renderDataTable = (
    data,
    tableType,
    actionBodyTemplate,
    lockerTypeId
  ) => {
    const isPartnerTable = tableType === "partner";

    return (
      <>
        <div className="text-center text-xl uppercase tracking-wide font-bold text-black">
          {data?.[0]?.lockerType || getLockerTypeLabel(lockerTypeId)} Locker
        </div>

        {/* <p className="font-bold text-center">{title}</p> */}
        <div className="flex justify-between items-center pb-4">
          <div className="flex flex-row">
            <p className="text-start mr-[3px] text-black">Total: </p>
            <p className="font-bold text-start text-black">{data?.length}</p>
          </div>
          <div>
            {headerAdd({
              type: tableType === "partner" ? 0 : 1,
              lockerTypeId: lockerTypeId,
            })}
          </div>
        </div>
        <DataTable
          value={data}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="Page {currentPage} of {totalPages}"
          paginator
          paginatorRight
          rowsPerPageOptions={[5, 10, 20, 50]}
          rows={5}
          exportFilename="Locker Fees"
          stripedRows={true}
          showGridlines={true}
          removableSort
        >
          <Column
            header="Locker Type"
            field="lockerType"
            className="border border-gray-400 w-[150px]"
            headerClassName={headerClassName(lockerTypeId, true)}
          />

          {isPartnerTable && (
            <Column
              header="Partner Category"
              sortable
              field="partnerCategory"
              className="border border-gray-400 w-[230px]"
              headerClassName={headerClassName(lockerTypeId, true)}
              body={(rowData) => (
                <Tag
                  icon={
                    rowData.partnerCategory === "Seller"
                      ? "fa-solid fa-store"
                      : "fa-solid fa-truck-fast"
                  }
                  className={`${
                    rowData.partnerCategory === "Seller"
                      ? "border border-secondary-darkGray bg-white text-black"
                      : "border text-secondary-darkGray border-primary-primaryYellow bg-white"
                  } text-sm space-x-1 w-[90px]`}
                >
                  {rowData.partnerCategory}
                </Tag>
              )}
            />
          )}
          {isPartnerTable && (
            <Column
              header="Partner Type"
              field="partnerType"
              className="border border-gray-400"
              headerClassName={headerClassName(lockerTypeId, true)}
            />
          )}

          {!isPartnerTable && (
            <Column
              header="User Type"
              sortable
              field="userType"
              className="border border-gray-400"
              headerClassName={headerClassName(lockerTypeId, true)}
            />
          )}

          <Column
            header=""
            className="border border-gray-400 w-[20px]"
            headerClassName={headerClassName(lockerTypeId, true)}
            body={(rowData) =>
              actionBodyTemplate(
                rowData,
                rowData.lockerTypeId,
                isPartnerTable ? 0 : 1
              )
            }
          />
        </DataTable>
      </>
    );
  };

  const actionBodyTemplate = (rowData, lockerTypeId, type) => {
    return (
      <div className="flex gap-2">
        {type == 1 && (
          <PrimereactBUtton
            className="bg-primary-primaryYellow text-secondary-darkGray p-2"
            // value=""
            icon={"pi pi-pencil"}
            onClick={() => {
              // window.location.href = `/operator/admin/locker-fees/edit-user-fees/${lockerTypeId}/${rowData.userTypeId}`;
              window.open(
                `/operator/admin/locker-fees/edit-user-fees/${lockerTypeId}/${rowData.userTypeId}`,
                "_blank"
              );
            }}
          />
        )}
        {type == 0 && (
          <PrimereactBUtton
            className="bg-primary-primaryYellow text-secondary-darkGray p-2 "
            // value="Edit"
            icon={"pi pi-pencil"}
            onClick={() => {
              window.open(
                `/operator/admin/locker-fees/edit-partner-fees/${lockerTypeId}/${rowData.partnerTypeId}`,
                "_blank"
              );
              // window.location.href = `/operator/admin/locker-fees/edit-partner-fees/${lockerTypeId}/${rowData.partnerTypeId}`;
            }}
          />
        )}
      </div>
    );
  };

  const lockerTypes = ["Parcel", "Fridge"];

  const renderTabContent = (tableType) => {
    return (
      <div className="grid grid-cols-2 space-x-3">
        {lockerTypesData.map(({ label, value }) => {
          const lockerTypeData =
            groupedData[label]?.[
              tableType === "partner" ? "partners" : "users"
            ] || [];

          //   const lockerTypeData = [];
          return (
            <Card
              key={label}
              className={`${
                label === "Parcel"
                  ? "bg-primary-primaryYellow"
                  : "bg-primary-primaryYellowLight"
              } col-span-1`}
            >
              {renderDataTable(
                lockerTypeData,
                tableType,
                actionBodyTemplate,
                value // constant lockerTypeId like "1", "2"
              )}
            </Card>
          );
        })}
      </div>
    );
  };

  return (
    <ContentContainer containerTitle={"Locker Fees"}>
      <Accordion multiple activeIndex={[0, 1]}>
        <AccordionTab
          headerClassName="text-center uppercase text-xl tracking-wide"
          header="Locker Fees by Partner"
        >
          {renderTabContent("partner")}
        </AccordionTab>

        <AccordionTab
          headerClassName="text-center uppercase text-xl tracking-wide"
          header="Locker Fees by User"
        >
          {renderTabContent("user")}
        </AccordionTab>
      </Accordion>
      {/* </Card> */}
    </ContentContainer>
  );
}
